import Indomie from '../../../assets/sponsors/indomie.png';
import Hakumori from '../../../assets/sponsors/hakumori.png';
import WPM from '../../../assets/sponsors/wpm.png';
import Woods from '../../../assets/sponsors/woods.png';
import Sakatonik from '../../../assets/sponsors/sakatonik.png';
import Promag from '../../../assets/sponsors/promag.png';
import ModoYoga from '../../../assets/sponsors/modoyoga.png';
import ITPC from '../../../assets/sponsors/ITPC Logo.png';
import Taphouse from '../../../assets/sponsors/taphouse small logo.png';
import Yeos from '../../../assets/sponsors/YEOS_LOGO_FULLCOLOUR_CMYK.jpg';
import Wizeprep from '../../../assets/sponsors/wizeprep.webp';
import Hive from '../../../assets/sponsors/Hive.png';
import FV from '../../../assets/sponsors/FV.png';
import PBG from '../../../assets/sponsors/pbg.webp';
import Vellum from '../../../assets/sponsors/vellum_wellness.jpeg';
import Skoah from '../../../assets/sponsors/sko_blue_logo.jpg';

export const SPONSORS = [
  {
    name: 'Indomie',
    link: 'https://indomieonline.ca/',
    logo: Indomie,
    description: "Indomie is a globally recognized instant noodle brand originating from Indonesia. Known for its rich flavors and quick preparation, Indomie offers a variety of noodle options, from classic Mi Goreng (fried noodles) to flavorful soup-based varieties. It has gained popularity worldwide, especially among students and busy professionals, for its affordability, convenience, and authentic taste. The brand is a staple in many households, loved for its signature seasoning packets that create a delicious and satisfying meal in minutes. Indomie continues to innovate with new flavors, catering to different taste preferences while maintaining its iconic quality."
  },
  {
    name: 'Hakumori',
    link: 'https://hakumori.shop/',
    logo: Hakumori,
    description: "A specialty store offering high-quality Japanese-inspired products, ranging from unique home decor to stylish accessories. Hakumori combines traditional craftsmanship with modern aesthetics to create timeless pieces."
  },
  {
    name: 'Westpath Maple Consulting',
    link: 'https://www.wpmaple.com/',
    logo: WPM,
    description: "WestPath Maple (WPM) is a consultancy firm specializing in education and business solutions, WPM assists international students in pursuing higher education in Canada and supports small to medium-sized businesses with strategic financial, managerial, and IT consultancy. With a strong presence in Canada, WPM provides expert guidance to help students and businesses succeed in a global landscape."
  },
  {
    name: 'Woods Lozenges',
    link: 'https://www.kalbeconsumerhealth.com/id/en/brands/respiratory-care/woods',
    logo: Woods,
    description: "A trusted brand for respiratory care, Woods Lozenges provide relief from coughs, sore throats, and other minor throat irritations. Infused with menthol and herbal ingredients, they offer a soothing effect and fresh breath."
  },
  {
    name: 'SAKATONIK ACTIV',
    link: 'https://drive.google.com/file/d/1xdk_AdWLUjVYVRRyRzpr_DWrNWzvwEGy/view?usp=drive_link',
    logo: Sakatonik,
    description: "A health supplement brand designed to boost energy and overall well-being. Packed with essential vitamins and minerals, SAKATONIK ACTIV supports an active and healthy lifestyle."
  },
  {
    name: 'PROMAG',
    link: 'https://www.kalbeconsumerhealth.com/id/en/brands/digestive-and-skin/promag',
    logo: Promag,
    description: "A digestive health brand specializing in antacid products that provide quick relief from heartburn, acid reflux, and indigestion. Promag is a trusted solution for maintaining stomach health."
  },
  {
    name: 'Modo Yoga',
    link: 'https://modoyoga.com/east-vancouver/',
    logo: ModoYoga,
    description: "A global community of hot yoga studios committed to sustainability and mindfulness. Modo Yoga offers a welcoming space for practitioners of all levels to develop strength, flexibility, and inner peace."
  },
  {
    name: 'ITPC',
    link: 'https://itpcvancouver.com/',
    logo: ITPC,
    description: "The Indonesian Trade Promotion Center (ITPC) Vancouver is a trade representative under the Ministry of Trade of the Republic of Indonesia. ITPC Vancouver is part of a global network with the primary goal of enhancing trade between Indonesia and Canada."
  },
  {
    name: "Yeo's",
    link: 'https://yeosusa.com/',
    logo: Yeos,
    description: "Yeo's is known for its refreshing drinks like soy milk, chrysanthemum tea, and coconut water, as well as its flavorful sauces and instant noodles."
  },
  {
    name: 'Wizeprep',
    link: 'https://www.wizeprep.com/',
    logo: Wizeprep,
    description: "An online learning platform providing high-quality tutoring and exam preparation resources for students. Wizeprep helps learners excel with comprehensive study materials and expert guidance."

  },
  {
    name: 'Hive Gym',
    link: 'https://hiveclimbing.com/',
    logo: Hive,
    description: "A premier climbing and fitness facility offering bouldering walls, strength training areas, and community-driven classes. The Hive fosters a supportive environment for climbers of all levels."
  },
  {
    name: 'FV',
    link: 'https://forbiddenvancouver.ca/',
    logo: FV,
    description: "A unique walking tour company that brings Vancouver’s hidden history to life. FV offers immersive storytelling experiences that explore the city’s dark, mysterious, and untold past."
  },
  {
    name: 'Taphouse',
    link: 'https://thetaphouse.ca/',
    logo: Taphouse,
    description: "A popular bar and restaurant offering a diverse selection of craft beers, cocktails, and delicious food. Taphouse is known for its lively atmosphere, great service, and regular entertainment events."
  },
  {
    name: "Progression Bouldering Gym",
    link: "https://www.progressionbouldering.com/",
    logo: PBG,
    description: "Bouldering gym in the heart of Vancouver. 18,000 sq. ft. of climbing, community, and good vibes in Vancouver. Climb, Eat at Progression Cafe, and Recover at our on-site Sports Health Clinic."
  },
  {
    name: "Vellum Wellness",
    link: "https://www.vellumwellness.com/",
    logo: Vellum,
    description: "At Vellum Wellness, we practice Aromachology, the science of how scent affects emotions. Scent has a powerful connection to memory. Use the science of scent to transform your mood."
  },
  {
    name: "Skoah",
    link: "https://www.skoah.com/",
    logo: Skoah,
    description: "Skoah is a wellness brand offering natural and organic products for body care, hair care, and home care. Their products are designed to promote health and well-being through clean ingredients."
  }
];
